import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {BuildingElementFunction, BuildingElementFunctionApiService} from '@cas-hub/acabim-common-client';

@Component({
    selector: 'acabim-admin-delete-functional-properties',
    templateUrl: './delete-functional-properties.component.html',
    styleUrls: ['./delete-functional-properties.component.scss']
})
export class DeleteFunctionalPropertiesComponent implements OnInit {
    @Input() functions: BuildingElementFunction[] = [];
    @Output() deleteResult = new EventEmitter<boolean>();
    isLoading = false;

    constructor(private readonly buildingElementFunctionService: BuildingElementFunctionApiService) {
    }

    ngOnInit(): void {
        this.isLoading = false;

        console.log(this.functions);
    }

    deleteRecords() {
        this.isLoading = true;
        const funcitonGUIDS: string[] = [];
        this.functions.forEach(func => {
            funcitonGUIDS.push(func.guid);
        });
        this.buildingElementFunctionService.deleteFunctions(funcitonGUIDS).subscribe(data => {
            this.isLoading = false;
            this.deleteResult.emit(true);
        });
    }
}
